import React from "react";
import QueryAllNews from "./QueryAllNews";
import LayoutMain from "../../00LayoutMain/LayoutMain";

function NewsGlobalOut(props) {
     return (
         <LayoutMain title={props.title} description={props.description} lang={props.lang}>
             <main className="CompanyNews StandartPage">
                <QueryAllNews PrerenderTexts={props.PrerenderTexts} lang={props.lang}/>
             </main>
         </LayoutMain>
        )}

export default NewsGlobalOut
